<template>
    <dashboard-layout tit="마이인재풀 관리">
        <template slot="contents">
            <v-tabs class="v-tabs--underline mb-20 mb-lg-40">
                <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/dashboard/human-resource/${value}`">{{ text }}</v-tab>
            </v-tabs>
            <!-- <v-divider class="mb-20 mb-lg-40" style="border-color: #E9E9E9" /> -->
            <v-tabs-items :value="tab" class="fill-height">
                <human-resource-recruits :tab="TABS.RECRUITS.value" :title="TABS.RECRUITS.text" />
                <human-resource-applicants :tab="TABS.APPLICANTS.value" :title="TABS.APPLICANTS.text" />
                <human-resource-favorites :tab="TABS.FAVORITES.value" :title="TABS.FAVORITES.text" />
                <human-resource-blacklist :tab="TABS.BLACKLIST.value" :title="TABS.BLACKLIST.text" />
                <human-resource-qualifiers :tab="TABS.QUALIFIERS.value" :title="TABS.QUALIFIERS.text" />
            </v-tabs-items>
        </template>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";

import HumanResourceApplicants from "@/components/dashboard/company/human-resource/human-resource-applicants.vue";
import HumanResourceBlacklist from "@/components/dashboard/company/human-resource/human-resource-blacklist.vue";
import HumanResourceFavorites from "@/components/dashboard/company/human-resource/human-resource-favorites.vue";
import HumanResourceRecruits from "@/components/dashboard/company/human-resource/human-resource-recruits.vue";
import HumanResourceQualifiers from "@/components/dashboard/company/human-resource/human-resource-qualifiers.vue";

const TABS = {
    RECRUITS: { value: "recruits", text: "합격 지원자 관리" },
    APPLICANTS: { value: "applicants", text: "공고 지원자 관리" },
    FAVORITES: { value: "favorites", text: "찜한 지원서 관리" },
    BLACKLIST: { value: "blacklist", text: "블랙리스트 관리" },
    QUALIFIERS: { value: "qualifiers", text: "인재 검색" },
};

const tabs = Object.values(TABS);

const baseUrl = "/dashboard/human-resource";
const tab__initial = tabs[0].value;

export default {
    components: {
        DashboardLayout,

        HumanResourceApplicants,
        HumanResourceBlacklist,
        HumanResourceFavorites,
        HumanResourceRecruits,
        HumanResourceQualifiers,
    },
    props: {
        tab: { type: String, default: tab__initial },
    },
    data: () => ({
        tabs,
        TABS,

        loading: false,
    }),
    mounted() {
        this.init();
    },
    watch: {
        "$route.path"() {
            this.syncPath();
        },
    },
    methods: {
        init() {
            this.loading = false;
            this.recruitments = [];
            this.syncPath().then(this.search);
        },
        async syncPath() {
            const path = `${baseUrl}/${this.tab}`;
            if (this.$route.path != path) this.$router.replace({ path });
        },
    },
};
</script>

<style></style>
